import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener, Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {TelegramService} from '../../../../pages/page-telegram/telegram.service';
import {from, Subject, Subscription, takeUntil} from 'rxjs';
import {ModalService} from '../../../../services/modal.service';

declare var $: any;

import {GalleryService} from '../../../../services/gallery.service';
import {AllService} from '../../../../services/all.service';
import {VkService} from '../../../../pages/page-vk/vk.service';
import {AttachmentPhoto, IMessengerConnector, Message} from '../../../../types/all.type';
import {DomSanitizer} from '@angular/platform-browser';
import {calcDiv, isMobile, log} from '../../../../functions';
import {HttpClient} from '@angular/common/http';
import {FileSaverService} from 'ngx-filesaver';
import {InterfaceService} from '../../../../services/interface.service';
import {AppService} from '../../../../services/app.service';
import {debounceTime, filter} from 'rxjs/operators';

@Component({
  selector: 'app-message-attachments',
  templateUrl: './message-attachments.component.html',
  styleUrls: ['./message-attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageAttachmentsComponent implements OnInit, OnDestroy {
  detectChangesTimeout: NodeJS.Timeout;
  // @Input() vizible: boolean;
  @Input() message: Message;
  @Input() Service: IMessengerConnector;
  @Input() messageBody: HTMLDivElement;
  @Input() messagesContainer: HTMLDivElement;
  @Input() isAvatar: boolean;
  @ViewChild('attachmentWrap') public attachmentWrap!: ElementRef;
  @Input() lvl = 1;
  public isMobile: boolean = isMobile();
  private resizeTimeout: NodeJS.Timeout;
  private getFile$Subscription: Subscription;
  public isGallery = false;
  public arGalleryTypes = ['photo', 'location', 'video_iframe', 'document'];
  private destroy$: Subject<void> = new Subject();

  constructor(
    private http: HttpClient,
    private _FileSaverService: FileSaverService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    public allService: AllService,
    public galleryService: GalleryService,
    public modalService: ModalService,
    public cd: ChangeDetectorRef,
    public telegramService: TelegramService,
    public interfaceService: InterfaceService,
    public appService: AppService
  ) {
    this.cd.detach();
  }

  ngOnInit(): void {
    this.interfaceService.thumbResize$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe((id) => {
      this.thumbResize();
    });
    this.message.attachments = this.message.attachments.sort((a: any, b: any) => {
      return this.arGalleryTypes.indexOf(b.type);
    });
    from(this.message.attachments || [])
      .pipe
      // filter((v: any) => (v.type === 'location' || v.type === 'photo' || v.type === 'document') && v.thumb)
      ()
      .subscribe((attachment: any) => {
        if (attachment.thumb) {
          if (!attachment.thumb?.original_width) {
            attachment.thumb.original_width = attachment?.thumb?.width || 300;
            attachment.thumb.original_height = attachment?.thumb?.height || 200;
          }
          if (attachment?.thumb?.width < 180 && attachment.thumb.width) {
            attachment.thumb.width = attachment.thumb.width * 2;
            attachment.thumb.height = attachment.thumb.height * 2;
          }
        }
        switch (attachment.type) {
          case 'location':
            attachment.thumb.file_uri = `https://static-maps.yandex.ru/1.x/?ll=${attachment.longitude},${attachment.latitude}&size=250,250&z=13&l=map&pt=${attachment.longitude},${attachment.latitude},comma`;
            attachment.geo = this.sanitizer.bypassSecurityTrustResourceUrl(
              'geo:' + attachment.latitude + ',' + attachment.longitude
            );
            break;
          case 'photo':
          case 'document':
          case 'video_iframe':
          case 'gift':
            if (attachment.thumb) {
              this.getThumb(attachment);
            }
            if (!attachment.file_uri && attachment?.file_id) {
              attachment.file_uri = this.Service.getFileSrc(attachment);
            }
            break;
          case 'video':
          case 'animation':
          case 'video_note':
            if (!attachment.file_uri && attachment?.file_id) {
              attachment.file_uri = this.Service.getFileSrc(attachment);
            }
            break;
          case 'web_page':
            if (attachment.thumb) {
              this.getThumb(attachment);
            }
            break;
        }
        if (attachment.file_size) {
          attachment.file_size_convert = this.appService.bytesToSize(attachment.file_size);
        }
      });
    // log('INIT MessageAttachmentsComponent');.pipe()
    this.thumbResize();
  }

  thumbResize() {
    let photoSizes = 130;
    let messageBodySize = 0;
    const marginPhoto = 3;
    const outerPadding = 14.6 * 2 * (this.lvl - 1);
    let maxWidth = (this.messagesContainer?.offsetWidth) - 32;
    const setBodySize = (size: number): number => {
      this.renderer.setStyle(this.messageBody, 'width', size - outerPadding + 'px');
      return this.messageBody.offsetWidth;
    };
    const calcMaxBodySize = (mw: number): number => {
      if (mw >= 700) {
        return (mw * 55) / 100;
      } else if (mw > 600) {
        return (mw * 65) / 100;
      } else if (mw > 500) {
        return (mw * 75) / 100;
      }
      return mw;
    };
    // TODO проверка!!!
    let gallLength = 0;
    if (this.message.attachments?.length > 1) {
      this.message.attachments.forEach((attachment) => {
        if (this.arGalleryTypes.includes(attachment.type)) {
          gallLength++;
        }
      });
      // const photosAttachments = <any>(this.message.attachments).find((v: any) => v.type === 'photo');
      // if(photosAttachments?.length > 1){
      if (gallLength > 1) {
        if (maxWidth <= 500) {
          messageBodySize = calcMaxBodySize(maxWidth);
          messageBodySize = setBodySize(messageBodySize);
          photoSizes = (messageBodySize - (this.isAvatar ? 25 : 0)) / 2 - marginPhoto;
        } else {
          messageBodySize = calcMaxBodySize(maxWidth);
          log(messageBodySize, maxWidth, this.message.attachments);
          ///
          let div = calcDiv(messageBodySize, 130);
          if (gallLength < div) {
            div = gallLength;
            messageBodySize = maxWidth / 3;
          } else if (div === 1 && gallLength > 1) {
            div = 2;
          }
          messageBodySize = setBodySize(messageBodySize);
          photoSizes = messageBodySize / div - marginPhoto;
          // log('div: ' + div + ' | photoSizes: ' + photoSizes + ' | maxWidth: ' + maxWidth + ' | messageBodySize: ' + messageBodySize
          //  + ' | outerPadding: ' + outerPadding + ' | lvl: ' + this.lvl);
        }
        this.isGallery = true;
      } else {
        if (!this.isMobile) {
          maxWidth = calcMaxBodySize(maxWidth);
        }
      }
    } else {
      if (!this.isMobile) {
        maxWidth = calcMaxBodySize(maxWidth);
      }
    }

    // log('RESIZE');

    from(this.message.attachments || [])
      .pipe(filter((v: any) => v.type != 'audio'))
      .subscribe((attachment: any) => {
        if (attachment.type === 'video' && !attachment?.thumb) {
          attachment.thumb = {
            width: 300,
            height: 200
          };
        }
        const thumb = attachment?.thumb;
        if (this.isGallery) {
          if (this.arGalleryTypes.includes(attachment.type) && thumb) {
            thumb.width = photoSizes;
            thumb.height = photoSizes;
          }
          if (attachment.type === 'video_iframe' && !thumb) {
            attachment.width = photoSizes;
            attachment.height = photoSizes;
          }

          if (attachment.type === 'document' && !thumb) {
            attachment.thumb = {
              width: photoSizes,
              height: photoSizes,
              original_width: 200,
              original_height: 200
            };
          }
        } else {
          if (attachment?.thumb) {
            if (maxWidth > 400) {
              maxWidth = 400;
            }
            const k = (maxWidth - outerPadding - (this.isAvatar ? 50 : 0)) / thumb.original_width;
            // log('maxWidth: ' + (maxWidth) + ' | ' + attachment.type + ' | ' +
            // this.lvl, 'original_width: ' + thumb.original_width + 'x' + thumb.original_height,
            // 'outerPadding: ' + outerPadding, 'newW: ' + (thumb.width * k), 'k:' + k ) ;
            const newWidth = thumb.original_width * k;
            if (thumb.original_width >= newWidth) {
              thumb.width = newWidth;
              thumb.height = thumb.original_height * k;
            } else if (attachment.type !== 'web_page') {
              thumb.width = thumb.original_width || 300;
              thumb.height = thumb.original_height || 200;
            }
            if (attachment.type === 'web_page' && attachment.description_length === 0) {
              thumb.width = thumb.original_width - 60;
              thumb.height = thumb.original_height - 60;
            }
            /*
                      if(attachment.file_id === "AgADAgADNLUxGz1kcEuLoB-DMOoJo8OxqKkuAAMBAAMCAANtAAO4ywUAARYE"){
                        log('thumbResize: maxWidth=' + maxWidth + ' | outerPadding: ' + outerPadding + ' k: ' + k, thumb);
                      }
                       */
          }
        }
      });
    this.cd.detectChanges();
  }

  getThumb(attachment) {
    if (!attachment?.thumb) {
      return;
    }
    if (!attachment?.thumb?.file_uri && attachment?.thumb?.file_id) {
      if (!(this.Service instanceof VkService)) {
        this.Service.getFile$(attachment.thumb.file_id, attachment.thumb.file_unique_id, 'getThumb')
          .pipe(takeUntil(this.destroy$))
          .subscribe((result: any) => {
            // tag("getFile$")
            attachment.thumb.file_uri = result.file;
            this.galleryService.addToGallery(attachment, this.message.text_list);
            this.detectChanges();
          });
      }
    } else {
      this.galleryService.addToGallery(attachment, this.message.text_list);
    }
    // this.Service.getThumbSrc(attachment);
    // this.detectChanges();
  }

  trackByFn(index, element: any) {
    return element ? element.id : undefined;
  }

  openMap(event, attachment) {
    if (!this.isMobile) {
      event.preventDefault();
      this.modalService.openModal('ModalMapComponent', attachment);
    }
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.MessageAttachmentsComponent++;
    // log('MessageAttachmentsComponent - Checking the view');
    return '';
  }

  loadImageAttachmentError(event, attachment) {
    attachment.thumb.file_uri = undefined;
    attachment.thumb.file_uri_error = true;
    this.cd.detectChanges();
  }

  videoIframeInit(attachment) {
    if (this.Service instanceof VkService) {
      this.Service.getVideoSrc$(attachment)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          attachment = res;
          this.cd.detectChanges();
        });
    }
  }

  detectChanges() {
    clearTimeout(this.detectChangesTimeout);
    this.detectChangesTimeout = setTimeout(() => {
      this.cd.detectChanges();
    }, 500);
  }

  downloadFile($event, attachment: AttachmentPhoto) {
    $event.preventDefault();
    // this.shareFile($event, attachment);
    // return;
    if (attachment.downloadInfo) {
      this.allService.openLocalFile(attachment.downloadInfo.local_uri, attachment.downloadInfo.mime_type);
    } else {
      let downloadUrl = attachment.file_uri;
      if (this.Service instanceof TelegramService) {
        if (downloadUrl?.length > 0 && downloadUrl.indexOf('?') > -1) {
          downloadUrl += '&download=true';
        }
      }
      this.allService.downloadFile(downloadUrl, attachment).subscribe((downloadInfo) => {
        log('downloadInfo: ');
        log(downloadInfo);
        this.cd.detectChanges();
      });
    }
  }

  async shareLink(downloadUrl) {
    const shareData = {
      title: 'MDN',
      text: 'Learn web development on MDN!',
      url: downloadUrl
    };

    try {
      await navigator.share(shareData);
    } catch (err) {
      console.log(err);
    }
  }

  shareFile($event, attachment: AttachmentPhoto) {
    $event.preventDefault();
    const downloadUrl: string = attachment.file_uri;

    this.http
      .get(downloadUrl, {
        observe: 'response',
        responseType: 'blob'
      })
      .subscribe((res) => {
        const filesArray = [
          new File([res.body], attachment.file_name || 'file.jpg', {
            type: res.body.type
          })
        ];
        try {
          navigator
            .share({
              files: filesArray,
              title: 'Pictures',
              text: 'Our Pictures.'
            })
            .then(() => alert('Share was successful.'))
            .catch((error) => alert('Sharing failed' + error));
        } catch (e) {
          // alert('No share: ' + e)
        }
        this.shareLink(downloadUrl).then((r) => {
        });
        // alert('open');
        // this._FileSaverService.save(res?.body, attachment?.file_name ||  'file.jpg');
      });
  }

  openIframeVideo(attachment: any) {
    this.galleryService.addToGallery(attachment);
    this.galleryService.openGallery(false, attachment.player);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
